var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components-container" },
    [
      _c(
        "el-form",
        { ref: "pram", attrs: { "label-width": "90px", model: _vm.pram } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "公司名称",
                prop: "name",
                rules: [
                  {
                    required: true,
                    message: "请填写公司名称",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写公司名称" },
                model: {
                  value: _vm.pram.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "name", $$v)
                  },
                  expression: "pram.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "公司税号", prop: "taxId" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写公司税号" },
                model: {
                  value: _vm.pram.taxId,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "taxId", $$v)
                  },
                  expression: "pram.taxId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "公司注册地", prop: "addressId" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  clearable: "",
                  options: _vm.addresData,
                  props: {
                    value: "id",
                    label: "name",
                    children: "child",
                    expandTrigger: "hover",
                  },
                },
                model: {
                  value: _vm.pram.addressId,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "addressId", $$v)
                  },
                  expression: "pram.addressId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "详细地址", prop: "address" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请填写详细地址" },
                model: {
                  value: _vm.pram.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "address", $$v)
                  },
                  expression: "pram.address",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.pram.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "status", $$v)
                    },
                    expression: "pram.status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("合作中")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("合作终止")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  resize: "none",
                  placeholder: "备注",
                },
                model: {
                  value: _vm.pram.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "remark", $$v)
                  },
                  expression: "pram.remark",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.handerSubmit("pram")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.cancelEdit } }, [
                  _vm._v("关闭"),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }